import { render, staticRenderFns } from "./Regional.vue?vue&type=template&id=e2686de8&scoped=true&"
import script from "./Regional.vue?vue&type=script&lang=js&"
export * from "./Regional.vue?vue&type=script&lang=js&"
import style0 from "./Regional.vue?vue&type=style&index=0&id=e2686de8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2686de8",
  null
  
)

export default component.exports